import { Layer, Spinner } from "grommet";

export function LoadingIndicator() {
  return (
    <Layer background={{opacity: true}}>
      <Spinner size="medium"/>
    </Layer>
  );
}
